var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#369443",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M17 26.3q-.1-.1.5-.6c.6-.2.6-1 .5-1.5l-.6.7s-.6.3-.6.8v.4s-.3-.7.1-1.3q.8-.8.3-2 .1.2-.4.8c-.4.4-.5.4-.5 1.2l-.1.4-.4-.8q-.1-.3.2-.7s1.1-.7.3-2.3q.1.2-.4.9-.4.4-.3 1l-.1.6s-.7-1.3-.2-2 .8-.8.3-2q.1.2-.5 1c-.5.3-.4 1-.4 1v.5s-.7-1.3 0-2c.5-.6.5-1 .2-2l-.3.7q-.6.1-.5 1.3v.7l-.4-.9v-.9c.3-.3 1.1-1.3.1-2.7l-.3.9v1.2l-.2.8s-.4-.8-.3-1.7q0-1.5-1.1-2.2s-.6 1.4.2 2.1c0 0 .7.7.9 1.6 0 0-.6 0-1-1s-1.5-.8-1.6-.8c0 0 .2 1.4 1.7 1.9 0 0 1 .1 1.2.9l.2.7-.6-.5c-.3-.5-.2-.5-1.2-.6l-.6-.3s.4 1.5 1.5 1.5c0 0 1-.1 1.5 1.2l-.3-.2q-.2-.2-1.2-.2h-1s.7 1.2 1.7.8 1.5 1 1.5 1.1l-.3-.3q-.3-.4-1.3-.1h-1s.5 1 1.6.8a1.3 1.3 0 0 1 1.5.8H15q0-.3-1.3-.1c-.8.3-1.1 0-1.1 0s.4.8 1.3 1l.7-.2a1 1 0 0 1 1.2.4h-.3s-.6-.3-1 0c0 0-.4.5-1 .4 0 0 .7.7 1.9.1 0 0 .4-.3.7 0s1-.3 1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M23.5 8.6s-.1-1.2.9-1.3l1.5.1.4.9-.2.6-.6.3s.1-1-.7-1H24q-.5.2-.6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M30.3 11.6c-.1.2-.7.3-.7.3s.6.4.8 1-6.8 0-6.8 0l.5-.5-.6-.2.5-.4.8-.8h-.5s.6-.2.8-1.2l.3-.6c.2-.3.2 0 .6-.4q.2-.2 0-.6-.1-.3-.7-.4t-.4-.7q.3-.3.5-.2-.1-.1.5-.5a3 3 0 0 1 1.6 0c.1 0 .8.2 1.1 1.2s0 1.2 1 2.7h-.7s.5.9 1.4 1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M26 7.7c-1 0-.6-.8-.6-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "m27.3 7.8-.2-.2q-.4-.5-.8-.2 0 .2-.4.3l.4.2.5.2.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#369443",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M16.9 28s0-.5.6-.5l2 2.7s0 .2-1 .2h-.1c0 .2-1.5-2.4-1.5-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M19 24.9s-.6 1-1.3 1c0 0-1.3-.1-1.7.2q-.4.4-.6 1 0 1 .3.8s0 .5.4.4c0 0 0 .4.8.2s1-.2 1.2-1c.2-.7.3-.6.5-.7q.3-.3.7-.4c.3-.1 1.1-.6 1.4-.6s.3-1 .3-1h-.8l-.4-.6zm2.5-5.4s-.8.6-1.4 0q0 .2-.8.2-.7-.2-.7-.5-.1.1-.8 0-.5-.4-.4-.5-.2.2-1-.3-.3-.7 0-1s-.6.2-.8-.4l.2-.8s-1.5 0-2.1-.4c0 0-.5-.4-.2-.7 0 0-1.4-.2-1.7-.7l-.1-.4.1-.2s-1.5-.2-2-.7v-.7s-1.4-.3-2-1c0 0-.5-.3-.3-.8 0 0-2.3-.6-1.8-1.7 0 0-1-.3-.7-1.3 0 0-1-.5-.5-1.2.3-.7 1.5.1 2.9.5 0 0 3.7 1.2 5.5 1.5l5.2 7.7 3 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M21.5 13.8s-.5-.4-1.4 0q0 .2-.5 0v-.7c.7-.5 1-2 0-2.5 0 0-1.5-.9-6.7-2.2h-.7l-.4.4s-.3.7.5 1l.7.3q-.2 0-.5.3-.4.7.8 1l.5.2s-.7.2-.4.7c0 0 .3.5 1.3.6 0 0-.8.1-.3.8q0 .2 1 .5s-.6 0-.3.5q.5.7 1.5.8h.6s-.6.2-.3.7q0 .2 1 .4-.2.2.2.7h.7s-.1.5.4.7q0 .2.7 0s.3.7 1.3.2c1.1-.4.3-4.4.3-4.4Zm0 6.1s0 .9-1.3 2c0 0-1 .8-1 1.8s-.2 1-.5 1.4c0 0 .7 0 1.1-.5l-.1 1 .6-.4.4-.3v1.2l.3-.4s.6 0 .8-.9q-.2-.1 1-1s1-.3 1-.8-2.2-3-2.2-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M26.1 30.8s-.2 1-1 1c0 0-.6-.1-.5-1 0 0-.8.4-1-.7 0 0-.7.2-.7-.8 0 0-.7.1-.6-.8 0 0-.7.2-.7-.6 0 0-1.8-.3 1.9-3.6l3.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M26.5 26.4s-.6.5-1-.3c0 0-.5 0-.6-.4q-.2.1-.5-.4s-.6-.1-.6-.6c0 0-1 0 0-1.3 1.1-1.2 3 2 3 2zm.6-.3c.5 0 1 3.3 1 5.2q-.2 1.3-1 1.4-1-.1-1-1.4c-.2-2 .4-5.2 1-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M27 27.1q.8-.1.8-1t-.7-1.1q-.7.1-.8 1 .1 1 .8 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M24.6 30.8s0-1.8 1.6-4.3m-2.6 3.6s-.2-1 2-4c0 0-.3-.7.4-1.1m-3 4.3s-.2-1.1 2-3.6c0 0-.3-.6.5-1.1m-3.2 4s0-1.2 2.1-3.3c0 0 0-.7.6-1.1m-3.4 3.7s.1-1.3 2.2-3.2q-.2-.1.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M5 7.6s1.7 1 7 2m-6.3-.7s4.6 1.5 6.7 1.7m-4.9 0s2.7.9 5.8 1.4m-3.5.4s3 .7 4.5.8m-2.5.6 3.2.6m-1.5.7 2.6.3m-.3.8h1m-.3 1.3 1-.5m0 1.7.7-.7m.4 1.2q.2-.1.4-.7m1 1v-.7m0-.8v-.4m-2.7-7.3s.8.4 1.1.9q.3.7 0 1.2c0 .1-.6 1.3 0 2.1m-1.1 1 .3-.2m-2.1-1.1 1 .1M14.7 13h1.1m-2-1.3 1.3.2M13 10l1.8.4m1.8.7s-.8.7.1 1.4c0 0-.3.6.4 1.2m-.2.3s-.1 1.2 1.3 1.2c0 0-.3 1 1.1 1 0 0 .2.8 1.2.6m-2.2 9h-.7m-1.4.7s-.7-.1-.6 1.3m1-1s-.6 0-.6 1.4m6.6-4.9-.5.3q-.4.3-.6.2l.3-.6q.2-.6.3-.5m-.7-.5-.5.3q-.5.3-.6.2t.3-.6l.3-.5m.3 2.3-.5.3q-.4.3-.5.1l.3-.5.2-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M34.9 24.9s.6 1 1.4 1c0 0 1.3-.1 1.6.2l.7 1q-.1 1-.3.8s0 .5-.5.4c0 0 0 .4-.8.2-.7-.2-1-.2-1.2-1-.2-.7-.3-.6-.4-.7l-.8-.4c-.2-.1-1.1-.6-1.4-.6s-.2-1-.2-1h.7l.4-.6zm-2.4-5.4s.7.6 1.4 0q0 .2.8.2.7-.2.6-.5.2.1.8 0 .5-.4.4-.5s.7.1 1-.3q.3-.7 0-1s.7.2.9-.4l-.2-.8s1.5 0 2-.4c0 0 .6-.4.3-.7 0 0 1.3-.2 1.7-.7V14l-.1-.2s1.5-.2 2-.7v-.7s1.4-.3 2.1-1c0 0 .4-.3.2-.8 0 0 2.4-.6 1.8-1.7 0 0 1.1-.3.8-1.3 0 0 .9-.5.5-1.2s-1.6.1-3 .5c0 0-3.7 1.2-5.5 1.5l-5.2 7.7-3 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M32.4 13.8s.5-.4 1.4 0q.1.2.5 0v-.7c-.7-.5-1-2 0-2.5 0 0 1.5-.9 6.7-2.2h.7l.5.4s.2.7-.6 1l-.7.3.6.3q.2.7-.8 1l-.5.2s.6.2.3.7c0 0-.3.5-1.2.6 0 0 .7.1.2.8q.1.2-1 .5s.6 0 .3.5q-.5.7-1.5.8h-.6s.6.2.3.7q0 .2-.9.4s.2.5-.3.7h-.7s.2.5-.4.7q0 .2-.6 0s-.3.7-1.4.2-.3-4.4-.3-4.4Zm0 6.1s.1.9 1.4 2c0 0 1 .8 1 1.8-.1 1 0 1 .5 1.4 0 0-.8 0-1.2-.5l.1 1-.6-.4-.4-.3s.3.6 0 1.2l-.3-.4s-.5 0-.8-.9c0 0 0-.5-1-1 0 0-1-.3-1-.8.1-.5 2.3-3 2.3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M27.8 30.8s.3 1 1 1c0 0 .6-.1.5-1 0 0 .9.4 1-.7 0 0 .7.2.7-.8 0 0 .7.1.6-.8 0 0 .8.2.8-.6 0 0 1.7-.3-2-3.6l-3.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M27.5 26.4s.5.5.9-.3c0 0 .5 0 .6-.4q.2.1.5-.4s.6-.1.6-.6c0 0 1 0 0-1.3-1-1.2-2.9 2-2.9 2zm-.6-.3c-.6 0-1.2 3.3-1 5.2q0 1.3 1 1.4.8-.1 1-1.4c0-2-.5-5.2-1-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4c53d",
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M26.9 27.1q-.7-.1-.8-1 .1-1 .8-1.1.6.1.7 1t-.7 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M29.3 30.8s0-1.8-1.5-4.3m2.5 3.6s.2-1-1.9-4c0 0 .2-.7-.5-1.1m3.1 4.3s0-1.1-2-3.6c0 0 .2-.6-.6-1.1m3.2 4s0-1.2-2-3.3c0 0 0-.7-.7-1.1m3.5 3.7s-.2-1.3-2.3-3.2q.2-.1-.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M49 7.6s-1.7 1-7 2m6.2-.7s-4.5 1.5-6.7 1.7m5 0s-2.8.9-5.9 1.4m3.5.4s-3 .7-4.4.8m2.4.6-3.2.6m1.6.7-2.6.3m.3.8H37m.5 1.3s-.7-.2-1-.5m0 1.7q-.2 0-.7-.7m-.5 1.2q-.2-.1-.4-.7m-1 1v-.7m.2-.8v-.4m2.7-7.3s-1 .4-1.2.9c-.3.4 0 .9 0 1.2 0 .1.7 1.3 0 2.1m1.1 1-.3-.2m2.2-1.1-1 .1m1.7-1.4H38m2-1.3-1.3.2M41 10l-1.9.4m-1.7.7s.7.7-.2 1.4c0 0 .4.6-.4 1.2m.2.3s.1 1.2-1.3 1.2c0 0 .3 1-1 1 0 0-.2.8-1.2.6m2.2 9h.7m1.3.7s.7-.1.7 1.3m-1-1s.5 0 .5 1.4m-6.5-4.9.5.3q.5.3.6.2l-.3-.6q-.2-.6-.3-.5m.7-.5.5.3q.5.3.6.2t-.3-.6q-.1-.5-.3-.5m-.3 2.3.4.3q.4.3.5.1l-.2-.5q-.1-.5-.3-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081c6",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "m38.8 21.3-1.2 5.2-.5-.4 1.2-5-.8.1 2-3.5v4zm3.1 1.1-3.6 4.3-.3-.5 3.5-4.2-.7-.4 3.3-2.1-1.7 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081c6",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "m41 20.2-3.2 6.1-.4-.3 3.2-6.1-.8-.2 2.7-2.9-.9 4zm-4 8-.2 1 .7.7-1 3.9-.8-1.1-1.2.5 1-3.9.8-.2.2-1q.1-.1.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081c6",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "m37.3 27.6-.5.8.5.9-1.9 3.5-.5-1.3-1.3.2 1.8-3.5h1l.4-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081c6",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M37.4 27.8 36 29.4l.3 1-2.6 3-.2-1.5h-1.4l2.6-3 .9.2 1.3-1.7q.2 0 .4.4Zm-32-3.7q.6-.2.6-.6l-.2-.5-2-6.2-.2-.6-.5-.4h2.5q-.4.2-.5.6l.1.4 1.5 4.9 1.6-4.9v-.4q0-.4-.4-.6h2.4l-.5.4-.2.6-2 6.2-.2.5q-.2.1.6.6zm43-.7v-7.2l-.5-.4h2.3l-.5.4v7.5l.5.4h-2.3l.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M27 25.8s6.3-2.7 6.3-9H20.9c0 6.3 6.2 9 6.2 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a60032",
    stroke: "#010002",
    strokeWidth: 0.2,
    d: "M21.8 16.8v4s.5 1 1 1.5v-5.6zm2 0v6.6l.9.9v-7.5zm1.8 0V25l1 .6v-8.9zm6.7 0v4s-.5 1-1 1.5v-5.6zm-1.9 0v6.6l-1 .9v-7.5zm-1.9 0V25l-1 .6v-8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#162667",
    stroke: "#010002",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M33.3 12.2s-3 1.5-6.2-.2c-3.2 1.7-6.2.2-6.2.2v4.6h12.4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVi);
export default __webpack_public_path__ + "static/media/vi.8bf8b7a91bdad2905a76d999821e23d6.svg";
export { ForwardRef as ReactComponent };